import type { NuxtApp } from '#app';

declare const window: Window & {
  mboxes: {
    items: any[];
    firstPageLoad: boolean;
    push: (item: any) => void;
    replace: (items: any[]) => void;
    clear: () => void;
    onChange: () => void;
    onPageLoaded: () => void;
    setOnChange: (onChange: () => void, immediate?: boolean) => void;
  };
};

export default defineNuxtPlugin({
  name: 'adobe',
  parallel: true,
  setup(_nuxtApp) {
    const { $router } = _nuxtApp as NuxtApp;
    const mainStore = useMainStore();
    const userStore = useUserStore();

    window.mboxes?.setOnChange(() => {
      mainStore.mboxes = [...window.mboxes.items];
    });

    $router.afterEach(() => {
      window.mboxes?.onPageLoaded();
    });

    trackerUtmListener(userStore);
    auroraAudiencesListener(userStore);
  },
});

const trackerUtmListener = (userStore: any) => {
  document.body.addEventListener('trackerUtm', (event: any) => {
    const data = event.detail || [];

    if (!data.length) {
      logger.debug('No trackerUtm data was found.');
      return;
    }

    userStore.trackerUtm = event.detail;
    logger.debug('trackerUtm data was added.');
  });
};

const auroraAudiencesListener = (userStore: any) => {
  document.body.addEventListener('audiences_for_aurora', (event: any) => {
    const data = event.detail || [];

    if (!data.length) {
      logger.debug('No audiences for Aurora were found.');
      return;
    }

    userStore.tealiumAudiences = data;
    logger.debug('Audiences for Aurora were added.');
  });
};